function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Modal INSTEAD.
import React, { forwardRef, useState, useEffect, useImperativeHandle, useRef } from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { get, isArray, isFunction } from 'lodash';
import Icon from "../../../Display/Icon";
import UUOverlaySpinner from "./components/UUOverlaySpinner";
import UUOverlay from "./components/UUOverlay";
var Title = function Title(_ref) {
  var title = _ref.title,
    close = _ref.close,
    removeCloseIcon = _ref.removeCloseIcon,
    titleStyles = _ref.titleStyles,
    dataTestElementClose = _ref.dataTestElementClose;
  if (!title) {
    return null;
  }
  var titleClass = "p-20px border-b border-solid border-silver-color flex-2\n    box-border text-22px leading-4 font-normal";
  var titleCloseableClass = classNames(titleClass, 'flex', 'justify-between', 'items-center');
  if (removeCloseIcon) {
    return /*#__PURE__*/React.createElement("div", {
      className: titleClass,
      style: _objectSpread({}, titleStyles)
    }, title);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({}, titleStyles),
    className: titleCloseableClass,
    "data-test-element": dataTestElementClose
  }, title, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconCross",
    ariaLabel: "Close ".concat(title, " Modal"),
    onClick: close,
    tabIndex: "0"
  }));
};
Title.propTypes = {
  title: PropTypes.string,
  titleStyles: PropTypes.object,
  close: PropTypes.func.isRequired,
  removeCloseIcon: PropTypes.bool.isRequired,
  dataTestElementClose: PropTypes.string.isRequired
};
Title.defaultProps = {
  title: null,
  titleStyles: {}
};
var Footer = function Footer(_ref2) {
  var actions = _ref2.actions,
    footerStyles = _ref2.footerStyles;
  if (!actions) {
    return null;
  }
  var actionsClass = 'border-t border-solid border-silver-color p-15 box-border text-right flex-3';
  var actionItemsClass = 'mr-15px inline-block mr-0:last-child';
  if (isArray(actions)) {
    return /*#__PURE__*/React.createElement("div", {
      className: actionsClass
    }, actions.map(function (a, i) {
      return /*#__PURE__*/React.createElement("span", {
        key: get(a, 'props.id', i),
        className: actionItemsClass
      }, a);
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: actionsClass,
    style: _objectSpread({}, footerStyles)
  }, actions);
};
Footer.propTypes = {
  actions: PropTypes.node,
  footerStyles: PropTypes.object
};
Footer.defaultProps = {
  actions: null,
  footerStyles: {}
};
var UUModal = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(function () {
      return null;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    resolver = _useState4[0],
    setResolver = _useState4[1];
  var initialRender = useRef({
    renderOpen: false,
    renderResolve: false
  });
  var actions = props.actions,
    children = props.children,
    id = props.id,
    removeCloseIcon = props.removeCloseIcon,
    spinnerShow = props.spinnerShow,
    spinnerText = props.spinnerText,
    spinnerDescription = props.spinnerDescription,
    size = props.size,
    titleStyles = props.titleStyles,
    footerStyles = props.footerStyles,
    title = props.title,
    modalContentStyles = props.modalContentStyles,
    showBorderRadius = props.showBorderRadius,
    dataTestElementClose = props.dataTestElementClose,
    className = props.className,
    customSize = props.customSize,
    dataId = props['data-testid'],
    modal = props.modal;
  useEffect(function () {
    if (typeof document === 'undefined') return;
    var firstNameInput = document.getElementById('first-name');
    if (firstNameInput) {
      setTimeout(function () {
        firstNameInput.focus();
      }, 100);
    }
  }, []);
  useEffect(function () {
    if (initialRender.current.renderOpen) {
      setOpen(true);
    }
    initialRender.current.renderOpen = true;
  }, [resolver]);
  useEffect(function () {
    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dismiss';
    if (initialRender.current.renderResolve) {
      setResolver(action);
    }
    initialRender.current.renderResolve = true;
  }, [open]);
  var modalSizeObject = {
    mini: 'w-275 min-h-0',
    small: 'w-400',
    normal: 'w-600',
    large: 'w-800',
    jumbo: 'w-1000',
    full: 'w-9/10'
  };
  var modalSize = size in modalSizeObject ? modalSizeObject[size] : modalSizeObject.normal;
  var openPaperClass = "transform -translate-x-1/2 -translate-y-1/2 z-1500 top-1/2 left-1/2 opacity-100 text-light-medium-grey bg-white transition-all duration-300 delay-0 ease-in-out\n  box-border font-regular-font shadow-modal rounded-2 max-h-90vh fixed max-w-9/10 flex flex-col flex-no-wrap";
  var dialogPaperClass = classNames(openPaperClass, modalSize, {
    rounded: showBorderRadius
  });
  var modalContent = 'flex-4 py-21px px-20px overflow-y-auto text-base w-full box-border max-h-90vh relative';
  var onRequestClose = function onRequestClose() {
    return null;
  };
  var onEscape = function onEscape(e) {
    if (e.key === 'Escape' && !modal) {
      onRequestClose();
    }
  };
  var _closeModal = function closeModal() {
    if (typeof document === 'undefined') return;
    document.removeEventListener('keyup', onEscape);
    setOpen(false);
  };
  onRequestClose = function onRequestClose() {
    if (isFunction(props.onRequestClose)) {
      return props.onRequestClose();
    }
    return _closeModal();
  };
  var onOverlayClick = function onOverlayClick() {
    if (!modal) {
      onRequestClose();
    }
  };
  var getModalClass = function getModalClass() {
    return classNames({
      dialog: true,
      open: open
    });
  };
  var focusTrap = function focusTrap() {
    if (typeof document === 'undefined') return;
    var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    var modalId = document.querySelector("#".concat(props.id)); // select the modal by it's id

    var firstFocusableElement = modalId.querySelectorAll(focusableElements)[0];
    var focusableContent = modalId.querySelectorAll(focusableElements);
    var lastFocusableElement = focusableContent[focusableContent.length - 1];
    firstFocusableElement.focus();
    document.addEventListener('keydown', function (e) {
      var isTabPressed = e.key === 'Tab';
      if (!isTabPressed) {
        return;
      }
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault();
      }
    });
    firstFocusableElement.focus();
  };
  var _openModal = function openModal() {
    if (typeof document !== 'undefined') {
      document.addEventListener('keyup', onEscape);
    }
    return new Promise(function (resolve) {
      setResolver(resolve);
      if (props.focusTrap) {
        focusTrap();
      }
    });
  };
  useImperativeHandle(ref, function () {
    return {
      openModal: function openModal() {
        _openModal();
      },
      closeModal: function closeModal() {
        _closeModal();
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: classNames(className, "".concat(getModalClass()), customSize ? 'custom' : ''),
    "data-testid": dataId,
    hidden: !open
  }, /*#__PURE__*/React.createElement(UUOverlay, {
    open: open,
    autoLockScrolling: true,
    onClick: onOverlayClick
  }), /*#__PURE__*/React.createElement("div", {
    className: dialogPaperClass,
    style: customSize
  }, /*#__PURE__*/React.createElement(UUOverlaySpinner, {
    show: spinnerShow,
    text: spinnerText,
    description: spinnerDescription
  }), /*#__PURE__*/React.createElement(Title, {
    title: title,
    close: onRequestClose,
    removeCloseIcon: removeCloseIcon,
    titleStyles: titleStyles,
    dataTestElementClose: dataTestElementClose
  }), /*#__PURE__*/React.createElement("div", {
    className: modalContent,
    style: _objectSpread({}, modalContentStyles)
  }, children), /*#__PURE__*/React.createElement(Footer, {
    footerStyles: footerStyles,
    actions: actions
  })));
});
UUModal.propTypes = {
  /** Class name for reference */
  className: PropTypes.string,
  /** Actions to perform, usually submit and cancel */
  actions: PropTypes.node,
  /** Child element, content of the modal */
  children: PropTypes.node.isRequired,
  /** Id for reference */
  id: PropTypes.string,
  modal: PropTypes.bool,
  focusTrap: PropTypes.bool,
  onRequestClose: PropTypes.func,
  /** If true, removes close icon from modal */
  removeCloseIcon: PropTypes.bool,
  /** Sets the size of modal */
  size: PropTypes.oneOf(['mini', 'small', 'normal', 'large', 'jumbo', 'full']),
  /** If true, shows spinner */
  spinnerShow: PropTypes.bool,
  /** Shows spinner text, if spinnerShow is true */
  spinnerText: PropTypes.string,
  /** Shows spinner desciption, if spinnerShow is true */
  spinnerDescription: PropTypes.string,
  /** Sets style for title */
  titleStyles: PropTypes.object,
  /** Sets style for footer */
  footerStyles: PropTypes.object,
  /** Title of the modal */
  title: PropTypes.node,
  /** Style for modal content */
  modalContentStyles: PropTypes.object,
  /** If true, shows border radius */
  showBorderRadius: PropTypes.bool,
  dataTestElementClose: PropTypes.string,
  /** Sets custom width and height of modal */
  customSize: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string
  }),
  /** Sets test id for automated tests */
  'data-testid': PropTypes.string
};
UUModal.defaultProps = {
  className: '',
  actions: null,
  footerStyles: {},
  id: '',
  modal: false,
  focusTrap: false,
  onRequestClose: null,
  removeCloseIcon: false,
  size: 'normal',
  spinnerDescription: '',
  spinnerShow: false,
  spinnerText: 'Submitting...',
  title: null,
  titleStyles: {},
  modalContentStyles: {},
  showBorderRadius: false,
  dataTestElementClose: 'modal-close',
  customSize: null,
  'data-testid': undefined
};
UUModal.displayName = 'UUModal';
export default UUModal;